module.exports = __webpack_public_path__ + "img/headimg.8a02227.webp";